import { ar } from "./locales/ar.js";
import { de } from "./locales/de.js";
import { es } from "./locales/es.js";
import { fr } from "./locales/fr.js";
import { pt } from "./locales/pt.js";
import { ru } from "./locales/ru.js";
import { zhCn } from "./locales/zh-cn.js";
import { en } from "./translations.js";
import { createLocalization } from "@scalar/localization";
//#region src/v2/features/localization/index.ts
/** API Client localization, also consumable beneath the API Reference provider. */
var { provideLocalization, useLocalization, resolveLocalization } = createLocalization({
	localeTranslations: {
		en: { apiClient: en },
		ru: { apiClient: ru },
		es: { apiClient: es },
		fr: { apiClient: fr },
		de: { apiClient: de },
		"zh-CN": { apiClient: zhCn },
		ar: { apiClient: ar },
		pt: { apiClient: pt }
	},
	defaultLocale: "en",
	rtlLocales: /* @__PURE__ */ new Set([
		"ar",
		"fa",
		"he",
		"ur"
	]),
	logPrefix: "[@scalar/api-client]"
});
//#endregion
export { provideLocalization, resolveLocalization, useLocalization };

//# sourceMappingURL=index.js.map